module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_power_outage_white.1401f3c4.png";